const SmallArrowLeftIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6667 10H3.33337M3.33337 10L8.33337 15M3.33337 10L8.33337 5"
      stroke="#06052b"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { SmallArrowLeftIcon };
